var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quotes",attrs:{"id":"quotes"}},[_c('Quotes',{attrs:{"data":_vm.testimonials}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }